module.exports = __webpack_public_path__ + "static/media/order-hook.01e209ef.svg";